import { createIdentifierStruct } from "@/modules/api/utils/jsonApiStructs";

import { takenTestQuestionSingleResourceType } from "./takenTestQuestionSingleResourceConsts";

export const takenTestQuestionSingleIdentifierStruct = createIdentifierStruct(
  takenTestQuestionSingleResourceType
);
